import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export function communicationsQueryOptions(orgId: string, deptId: string, language: string) {
  return queryOptions({
    queryKey: ['communications', 'templates', orgId, deptId, language] as const,
    enabled: Boolean(orgId && deptId),
    queryFn: async () => {
      const res = await api.api.org[':orgId'].department[':deptId'].communications.templates.$get({
        param: { orgId, deptId },
        query: { language }
      });
      if (!res.ok) throw new Error(i18n.t('errors.unexpected'));
      return res.json();
    }
  });
}
